// #1750 — the class grid is keyboard-first (design doc section 6): the judge
// calls rider numbers in whatever order they see them, so a scribe types and
// walks cells constantly. Native Tab order already advances left-to-right,
// row-by-row across `[data-grid-cell]` inputs (DOM order matches visual
// order), so this only needs to make Enter behave like Tab instead of
// submitting/doing nothing.
//
// #2623 — lifted into common-fe (gridCellNav.js) so scoreadmin-fe's
// numeric-only grid shares the exact same helper instead of growing its own
// copy that could drift. Re-exported here so every existing scribe-fe import
// site keeps working, but common-fe's version is NOT behavior-identical to
// the copy it replaced — two real deltas land here too:
//
//   - Disabled cells are now skipped instead of stopping the walk dead.
//     ClassGridRow.jsx passes disabled={Boolean(isConfirmed)} on the
//     observation, Total, and Place cells, all three also marked
//     data-grid-cell. Previously Enter into a confirmed row's first cell
//     called .focus() on a disabled element, the browser refused it, and
//     focus just stayed put (a de facto stop at the boundary). Now Enter
//     skips straight past every disabled cell in that confirmed row to the
//     next enabled one (that row's general-remarks field, not disabled) —
//     which is what a scribe reviewing a signed-off class already expects
//     Enter to do (keep walking), not what the old accidental stop gave them.
//   - Shift+Enter now genuinely mirrors Shift+Tab (moves backward). Nothing
//     in scribe-fe read e.shiftKey before this helper did, so a scribe who
//     happened to hold Shift while pressing Enter previously still moved
//     FORWARD (shiftKey was silently ignored); now that same keystroke moves
//     backward, matching every other Shift+<key> convention in the app.
//
// Both are believed improvements (an accidental dead stop, and Shift+Enter
// doing nothing useful, are both worse than the new behavior), but they ARE
// behavior changes on a live surface, not a no-op superset — verified against
// apps/scribe-fe/cypress/e2e/class-grid.cy.js's AC4 Enter-advances-focus case
// (run with --browser chrome; cy.realPress needs genuine CDP key events).
export { focusNextGridCell } from "common-fe";

// Numeric-aware rider-number sort. Ride.competitorNumber is z.string()
// (validation.js) so a naive string sort would put "10" before "2" — parse
// both as int and fall back to string compare when either side isn't
// numeric (blank/unassigned numbers still sort deterministically).
export function sortByCompetitorNumber(rides) {
  return [...rides].sort((a, b) => {
    const an = parseInt(a.competitorNumber, 10);
    const bn = parseInt(b.competitorNumber, 10);
    const aValid = !Number.isNaN(an);
    const bValid = !Number.isNaN(bn);
    if (aValid && bValid && an !== bn) return an - bn;
    if (aValid !== bValid) return aValid ? -1 : 1;
    return String(a.competitorNumber ?? "").localeCompare(String(b.competitorNumber ?? ""));
  });
}
